import { ChatState } from ".";
// import { config } from "config";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// const default_page_size = config.PAGE_SIZE;

const initialState: ChatState = {
  chats: [],
  users: [],
  messages: [],
  chat: null,
  loading: true,
  messageFilter: { page: 1, page_size: 10 },
  messageCount: 0,
  unreadCount: 0,
};

export const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    addChat: (state, action) => {
      state.chats.unshift(action.payload);
    },
    setMessages: (state, action) => {
      state.messages = action.payload;
    },
    appendMessages: (state, action) => {
      state.messages = [...action.payload, ...state.messages]; // Append new messages at the top
    },
    setMessagesCount: (state, action) => {
      state.messageCount = action.payload;
    },
    updateUnreadCount: (state, action) => {
      const { userId } = action.payload;
      const chatIndex = state.chats.findIndex((c) => c._id === userId);
      if (chatIndex !== -1) {
        state.chats[chatIndex].unreadCount = 0;
      }
      const unreadCount = state.chats.reduce(
        (acc, chat) => acc + (chat.unreadCount || 0),
        0
      );
      state.unreadCount = unreadCount;
    },

    addMessage: (state, action) => {
      const message = action.payload;
      const currentChat = state.chat;
      const chatIndex = state.chats.findIndex(
        (c) => c._id === message.receiver
      );

      if (chatIndex !== -1) {
        if (!currentChat || currentChat._id !== message.chat) {
          // Increment unread count for chat that received the message
          state.chats[chatIndex].unreadCount =
            (state.chats[chatIndex].unreadCount || 0) + 1;
        }
        state.chats[chatIndex].lastMessage = message;
      } else {
        const chatIndex = state.chats.findIndex(
          (c) => c._id === message.sendBy?._id
        );
        if (!currentChat || currentChat._id !== message.chat) {
          // Increment unread count for chat that received the message
          state.chats[chatIndex].unreadCount =
            (state.chats[chatIndex].unreadCount || 0) + 1;
        }
        if (chatIndex !== -1) {
          state.chats[chatIndex].lastMessage = message;
        }
      }
      const unreadCount = state.chats.reduce(
        (acc, chat) => acc + (chat.unreadCount || 0),
        0
      );
      state.unreadCount = unreadCount;
    },
    setChat: (state, action) => {
      state.chat = action.payload;
    },
    updateChatUser: (state, action) => {
      const user = action.payload;
      const chatIndex = state.chats.findIndex((c) => c._id === user._id);

      if (chatIndex !== -1) {
        state.chats[chatIndex] = { ...state.chats[chatIndex], ...user };
      }
    },
    setChats: (state, action) => {
      state.chats = action.payload;
    },
    setMessageFilter: (state, action) => {
      state.messageFilter = action.payload;
    },
    setUnreadCount: (state, action) => {
      state.unreadCount = action.payload;
    },
  },
});

const chatReducer = chatSlice.reducer;

export const chatActions = chatSlice.actions;
export default chatReducer;
